import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from "react";
import { fetchAuthSession } from "@aws-amplify/auth";

interface AuthContextType {
  idToken: string | null;
  refreshAuthSession: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [idToken, setIdToken] = useState<string | null>(null);

  const refreshAuthSession = async () => {
    try {
      const session = await fetchAuthSession();
      const tokenString = session.tokens?.idToken?.toString() ?? null;
      setIdToken(tokenString);
    } catch (error) {
      console.error("Error fetching auth session:", error);
      setIdToken(null);
    }
  };

  useEffect(() => {
    refreshAuthSession();
  }, []);

  return (
    <AuthContext.Provider value={{ idToken, refreshAuthSession }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
